import { Typography } from "@outschool/backpack";
import { TFunction, useTranslation } from "@outschool/localization";
import * as Time from "@outschool/time";
import { dayjs } from "@outschool/time";
import { useSession } from "@outschool/ui-auth";
import React from "react";

// eslint-disable-next-line i18next/no-literal-string
type ClassTimeFormatOption = "time" | "date-and-time";

function formatMeetingTime(
  start: Date,
  end: Date,
  isFlex: boolean,
  userTimeZone: string,
  formatOption: ClassTimeFormatOption,
  t: TFunction
): string {
  const startTime = dayjs.tz(dayjs(start), userTimeZone);

  const endTime = dayjs.tz(dayjs(end), userTimeZone);

  const timeRange = Time.briefDurationTimesString(
    startTime,
    endTime,
    userTimeZone
  );

  switch (formatOption) {
    // eslint-disable-next-line i18next/no-literal-string
    case "time":
      if (isFlex) {
        return t("Flexible Schedule");
      }

      return timeRange;

    // eslint-disable-next-line i18next/no-literal-string
    case "date-and-time":
      const classDay = Time.formatDateWithWeekday(startTime);

      if (isFlex) {
        // eslint-disable-next-line i18next/no-literal-string
        return classDay + " • " + t("Flexible Schedule");
      }

      // eslint-disable-next-line i18next/no-literal-string
      return classDay + " • " + timeRange;

    default:
      // @ts-ignore TS(2322): Type 'null' is not assignable to type 'string'.
      return null;
  }
}

type ClassTimeProps = {
  start: Date;
  end: Date;
  isFlex: boolean;
  formatOption: ClassTimeFormatOption;
};

export const ClassTime: React.FunctionComponent<ClassTimeProps> = ({
  start,
  end,
  isFlex,
  formatOption
}) => {
  const { userTimeZone } = useSession();
  const { t } = useTranslation(
    "client\\components\\teacher\\TeacherProfile\\UpcomingClass\\ClassTime"
  );

  const formattedTime = React.useMemo(
    // @ts-ignore TS(2345): Argument of type 'string | null' is not assignable... Remove this comment to see the full error message
    () => formatMeetingTime(start, end, isFlex, userTimeZone, formatOption, t),
    [start, end, isFlex, userTimeZone, formatOption, t]
  );

  return (
    <Typography
      variant="inherit"
      sx={{
        display: "block",
        color: "grey.500",
        fontSize: "14px",
        lineHeight: "20px"
      }}
    >
      {formattedTime}
    </Typography>
  );
};
